import React from 'react';
import {Box, Card, CardContent, CardHeader, Typography} from "@mui/material";

const SupportContactDetails = ({account}) => {

    return (

        <Card className="card">
            <CardHeader
                disableTypography={true}
                title={<Typography component="h2" variant="h2">Get help</Typography>}
            />
            <CardContent>

                { account === 'PIT' && (
                    <Box className="card-content">
                        <Typography variant="body1"><strong>Email</strong> <a href="mailto:support@premierit.com" target="_blank" rel="noreferrer">support@premierit.com</a></Typography>
                        <Typography variant="body1"><strong>Web</strong> <a href="https://support.premierit.com" target="_blank" rel="noreferrer">support.premierit.com</a></Typography>
                    </Box>
                )}

                { account === '' && (
                    <Box className="card-content">
                        <Typography variant="body1">Please contact your administrator</Typography>
                    </Box>
                )}

            </CardContent>
        </Card>

    );
}

export default SupportContactDetails;